<button
  (click)="toggleDropdown()"
  type="button"
  class="relative min-w-7 block"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin">
  <img
    class="w-full"
    src="https://res.cloudinary.com/superlikers/image/upload/v1768857658/icon_noti_drpxc1.svg"
    alt="Ícono de notificaciones"
    loading="lazy" />
  <p class="absolute top-1 -right-1.5 rounded-full text-[0.6rem]/none w-4 h-4 grid items-center bg-theme-redNegative">{{ noReadNotifications() }}</p>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  cdkConnectedOverlayHasBackdrop
  (backdropClick)="toggleDropdown()">
  <app-notification-list></app-notification-list>
</ng-template>
